import { LinearProgressProps, LinearProgress, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { SxProps } from '@mui/system';

function ProgressWithLabel(props: LinearProgressProps & { value: number }) {
  const { value } = props;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(
            value,
          )}%`}
        </Typography>
      </Box>
    </Box>
  );
}

type TLinearProgressWithLabel = {
  progress: number,
  color: LinearProgressProps['color']
  sx: SxProps<Theme>
};

const LinearProgressWithLabel: FC<TLinearProgressWithLabel> = ({ progress, color, sx }) => (
  <ProgressWithLabel
    color={color}
    variant="determinate"
    value={progress}
    sx={sx}
  />
);

export {
  LinearProgressWithLabel,
};
